// @jsxRuntime classic
// https://github.com/facebook/create-react-app/issues/9906
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
// import 'straightline-ui/dist/styles/theme.scss';
import 'src/scss/theme.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter, Switch } from 'react-router-dom';
import app from 'src/feathers';
import programming from 'src/images/programming.svg';
import { useChat } from 'src/lib/hooks';
import Error from 'src/pages/Error';
import {
  AppProvider,
  ConfirmModal,
  ErrorBoundary,
  ToastContainer
} from 'straightline-ui';

import { PrivateRoute, privateRoutes, publicRoutes, Route } from './routes';

function Chat() {
  useChat();
  return null;
}

function App() {
  return (
    <ErrorBoundary sentry={app.get('sentryClient')} img={programming}>
      <AppProvider app={app}>
        <QueryClientProvider client={app.get('queryClient')}>
          <BrowserRouter basename="/">
            <Switch>
              {publicRoutes.map((route, index) => (
                <Route
                  key={route.key || index}
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))}
              {privateRoutes.map((route, index) => (
                <PrivateRoute
                  key={route.key || index}
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))}
              <Route render={(props) => <Error {...props} />} />
            </Switch>
            <ToastContainer position="bottom-right" />
            <ConfirmModal />
            <Chat />
          </BrowserRouter>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </AppProvider>
    </ErrorBoundary>
  );
}

ReactDOM.render(<App />, document.getElementById('root'));
